// 2026-05-26 - FormuLearning - 회원가입 폼 컴포넌트
// 파일 위치: frontend/src/features/auth/RegisterForm.tsx

import { useState } from 'react'
import { register } from '../../api/auth'
import { useAuthStore } from '../../stores/authStore'

const DEFAULT_TENANT_ID = '00000000-0000-0000-0000-000000000001'

export default function RegisterForm({ onToggle }: { onToggle: () => void }) {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const login = useAuthStore((s) => s.login)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await register({ email, password, name, tenant_id: DEFAULT_TENANT_ID })
      await login(email, password)
    } catch {
      setError('Registration failed. Email may already exist.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label className="mb-1 block text-xs font-medium text-text-secondary">Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full rounded-md border bg-bg-input px-3 py-2 text-sm text-text-body outline-none"
          style={{ borderColor: 'var(--border-soft)' }}
          placeholder="Your name"
          required
        />
      </div>
      <div>
        <label className="mb-1 block text-xs font-medium text-text-secondary">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-md border bg-bg-input px-3 py-2 text-sm text-text-body outline-none"
          style={{ borderColor: 'var(--border-soft)' }}
          placeholder="you@example.com"
          required
        />
      </div>
      <div>
        <label className="mb-1 block text-xs font-medium text-text-secondary">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-md border bg-bg-input px-3 py-2 text-sm text-text-body outline-none"
          style={{ borderColor: 'var(--border-soft)' }}
          placeholder="Min 8 characters"
          minLength={8}
          required
        />
      </div>
      {error && <p className="text-sm text-danger">{error}</p>}
      <button
        type="submit"
        disabled={loading}
        className="w-full rounded-md bg-accent-purple px-4 py-2 text-sm font-semibold text-[#1a1b1e] transition-opacity hover:opacity-90 disabled:opacity-50"
      >
        {loading ? 'Creating account...' : 'Create Account'}
      </button>
      <p className="text-center text-xs text-text-secondary">
        Already have an account?{' '}
        <button type="button" onClick={onToggle} className="text-accent-purple hover:underline">
          Sign In
        </button>
      </p>
    </form>
  )
}
